import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeReferralsPage from "@/pages/employee/EmployeeReferralsPage";

export const Route = createFileRoute("/employee/referrals")({
  head: () => pageHead("Employee · Referrals", "AKIVA employee · referrals portal.", "/employee/referrals", true),
  component: EmployeeReferralsPage,
});
